/* Yoni Yoni - Cart drawer JS */
(function () {
  /* ------------------------------------------------------------------
     SELECTOR IS CART-SPECIFIC ON PURPOSE.

     This used to be document.querySelector('[data-yy-drawer]') - the same
     attribute the header's mobile MENU panel carries. querySelector returns
     the first match in the document, the header renders first, so this
     script was holding a reference to the navigation menu and opening that
     whenever the cart icon was clicked.

     Both drawers now have their own names. Do not widen this selector.
     ------------------------------------------------------------------ */
  const drawer = document.querySelector('[data-yy-cart-drawer]');
  if (!drawer) return;

  /* KACHING CART (Oct 2026): Kaching Cart app is the bag on this site. When it is
     installed, every route that would open this theme drawer opens Kaching's
     instead, so shoppers never get two bags stacked on top of each other.
     If the app is ever switched off, this drawer works again as before. */
  function kaching() {
    return window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function'
      && document.getElementById('kaching-cart') ? window.kachingCartApi : null;
  }

  function open() {
    const k = kaching();
    if (k) {
      drawer.classList.remove('is-open');
      drawer.hidden = true;
      document.body.classList.remove('yy-drawer-open');
      try { if (k.refreshCart) k.refreshCart(); } catch (err) {}
      k.openCart();
      return;
    }
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      document.body.classList.add('yy-drawer-open');
    });
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('yy-drawer-open');
    drawer.addEventListener('transitionend', () => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, { once: true });
  }

  /* Close buttons + overlay. Delegated, so it still works after the drawer
     re-renders its contents. */
  drawer.addEventListener('click', e => {
    if (e.target.closest('[data-yy-cart-drawer-close]')) close();
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  /* Opening. The header cart control is a <button data-yy-cart-open> that
     also fires a yy:cart:open event, so both routes are covered, along with
     a plain /cart link for anything else on the page. */
  document.addEventListener('yy:cart:open', open);
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-yy-cart-open], [data-yy-cart-toggle], a[href$="/cart"]');
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  /* Quantity + remove */
  async function updateLine(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      refreshDrawer(cart);
    } catch (err) { console.error('Cart update failed', err); }
  }

  drawer.addEventListener('click', e => {
    const line = e.target.closest('[data-yy-line-key]');
    if (!line) return;
    const key = line.dataset.yyLineKey;
    const countEl = line.querySelector('[data-yy-line-count]');
    if (!countEl) return;
    const count = parseInt(countEl.textContent, 10);

    if (e.target.closest('[data-yy-line-qty="minus"]')) updateLine(key, Math.max(0, count - 1));
    if (e.target.closest('[data-yy-line-qty="plus"]'))  updateLine(key, count + 1);
    if (e.target.closest('[data-yy-line-remove]'))      updateLine(key, 0);
  });

  /* Header cart bubble. The badge is only in the markup when the cart has
     something in it, so it has to be created on the first add. */
  function updateHeaderCount(count) {
    const btn = document.querySelector('[data-yy-cart-open]');
    if (!btn) return;
    let badge = btn.querySelector('.yy-hd__badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'yy-hd__badge';
        badge.setAttribute('aria-hidden', 'true');
        btn.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  /* Refresh via the Section Rendering API.
     The footer is NOT replaced wholesale - it holds the express checkout
     buttons, which Shopify injects with its own script on page load, and
     swapping its HTML throws them away until a full reload. Only the
     subtotal is updated in place. */
  async function refreshDrawer(cart) {
    try {
      const res  = await fetch('/?sections=yy-cart-drawer');
      const data = await res.json();
      const tmp  = document.createElement('div');
      tmp.innerHTML = data['yy-cart-drawer'];

      const newBody  = tmp.querySelector('[data-yy-cart-body]');
      const newFoot  = tmp.querySelector('.yy-drawer__foot');
      const newShip  = tmp.querySelector('[data-yy-ship]');
      const newCount = tmp.querySelector('[data-yy-cart-count]');
      const newTotal = tmp.querySelector('[data-yy-cart-total]');

      const oldBody  = drawer.querySelector('[data-yy-cart-body]');
      const oldFoot  = drawer.querySelector('.yy-drawer__foot');
      const oldShip  = drawer.querySelector('[data-yy-ship]');
      const oldCount = drawer.querySelector('[data-yy-cart-count]');
      const oldTotal = drawer.querySelector('[data-yy-cart-total]');

      if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
      if (newShip && oldShip) oldShip.innerHTML = newShip.innerHTML;
      if (newCount && oldCount) oldCount.textContent = newCount.textContent;

      if (newFoot && oldFoot) {
        if (newTotal && oldTotal) oldTotal.textContent = newTotal.textContent;
      } else if (!newFoot && oldFoot) {
        oldFoot.remove();
      } else if (newFoot && !oldFoot) {
        const panel = drawer.querySelector('.yy-drawer__panel');
        if (panel) panel.insertAdjacentHTML('beforeend', newFoot.outerHTML);
      }

      updateHeaderCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
    } catch (err) { console.error('Drawer refresh failed', err); }
  }

  /* Add to cart from the product page opens the drawer. Express checkout
     buttons submit the same form and must NOT be intercepted - they hand
     off to Shopify directly. */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('#yy-pdp-form, form[action$="/cart/add"]');
    if (!form) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;

    e.preventDefault();
    try {
      await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      await refreshDrawer(cart);
      open();
    } catch (err) { console.error('Add to cart failed', err); }
  });

  /* QUICK ADD FROM PRODUCT CARDS (Oct 2026 fix).
     Best Sellers and Collection Grid cards add with data-yy-add, handled by
     yy-ajax-add.js, which fires yy:cart:updated when it is done. Nothing was
     listening, so the drawer kept the contents it rendered at page load. A
     new visitor arriving with an empty bag added a product, tapped the bag,
     and saw "your bag is empty" with no checkout button. Refresh and open
     the drawer here so card adds behave like the product page. */
  document.addEventListener('yy:cart:updated', async e => {
    await refreshDrawer(e.detail);
    open();
  });
})();
